import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../../../hooks/authentication/useAuth';
import Footer from './Footer/Footer';
import ProfileHeaderWrapper from '../Header/HeaderLayout';

const MainFrame: React.FC<{ children?: React.ReactNode }> = () => {
    const auth = useAuth();

    return (
        <>
            {!auth.isLoggedIn && <Navigate to={'/login'} replace />}
            {auth.isLoggedIn && (
                <>
                    <ProfileHeaderWrapper displaySearch />
                    <Outlet />
                    <Footer />
                </>
            )}
        </>
    );
};

export default MainFrame;
